import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cleanId'
})
export class CleanIdPipe implements PipeTransform {
    transform(value: string) {
        return value.replace(/\s+/g, '_').replace(/[^\w-]/ig, '');
    }
}
